import { HistoryActions } from './actions';
// Keep all past/future states in this map (not in main state)
class StateRecorder {
    constructor() {
        Object.defineProperty(this, "past", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "future", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "records", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "locks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "recording", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    get isRecording() {
        return !!this.recording;
    }
    get isLocked() {
        return this.locks > 0;
    }
    lock() {
        this.locks += 1;
    }
    unlock(remvoeAll = false) {
        this.locks = remvoeAll ? 0 : Math.max(0, this.locks - 1);
    }
    record(state) {
        if (this.isRecording) {
            this.records += 1;
            return state;
            // this.commit(state);
        }
        this.records = 1;
        this.recording = {
            state: state.present,
            changesCount: 0,
        };
        return state;
    }
    commit(state) {
        if (!this.isRecording) {
            return state;
        }
        this.records = Math.max(0, this.records - 1);
        if (this.records > 0) {
            return state;
        }
        const { state: savedState, changesCount } = this.recording;
        this.recording = null;
        if (changesCount > 0) {
            if (savedState !== state.present) {
                this.past = [...this.past, savedState];
                this.dropFuture();
                return this.build(state.present);
            }
        }
        return state;
    }
    reject(state) {
        this.recording = null;
        return state;
    }
    undo(state) {
        this.unlock(true);
        const { past } = this;
        const { present } = state;
        if (!past.length) {
            return state;
        }
        const previous = past.pop();
        this.future.unshift(present);
        return this.build(Object.assign(Object.assign({}, present), previous));
    }
    redo(state) {
        this.unlock(true);
        const { future } = this;
        const { present } = state;
        if (!future.length) {
            return state;
        }
        const next = future.shift();
        this.past.push(present);
        return this.build(Object.assign(Object.assign({}, present), next));
    }
    clear(state) {
        this.unlock(true);
        this.dropPast();
        this.dropFuture();
        return {
            inPast: this.past.length,
            present: state.present,
            inFuture: this.future.length,
            lastModified: Date.now(),
        };
    }
    replace(present) {
        return this.build(present);
    }
    overwrite(present) {
        this.dropFuture();
        return this.build(present);
    }
    reduce(state, present) {
        if (this.isLocked) {
            return this.overwrite(present);
        }
        if (this.isRecording) {
            this.recording.changesCount += 1;
            return this.replace(present);
        }
        this.past = [...this.past, state.present];
        this.dropFuture();
        return this.build(present);
    }
    build(present) {
        return {
            inPast: this.past.length,
            present,
            inFuture: this.future.length,
            lastModified: Date.now(),
        };
    }
    dropPast() {
        this.past.splice(0, this.past.length);
    }
    dropFuture() {
        this.future.splice(0, this.future.length);
    }
}
export function undoableNew(reducer, undoableKeys) {
    undoableKeys = undoableKeys || [];
    // Call the reducer with empty action to populate the initial state
    const initialState = {
        inPast: 0,
        present: reducer(undefined, { type: 'INIT' }),
        inFuture: 0,
        lastModified: Date.now(),
    };
    // / TODO: store past / future outside of state
    const recorder = new StateRecorder();
    // Return a reducer that handles undo and redo
    return (state = initialState, action = { type: 'INIT' }) => {
        var _a;
        const { present } = state;
        switch (action.type) {
            case HistoryActions.reset.type: {
                recorder.unlock(true);
                return Object.assign({}, initialState);
            }
            case HistoryActions.lock.type: {
                recorder.lock();
                return state;
            }
            case HistoryActions.unlock.type: {
                recorder.unlock();
                return state;
            }
            case HistoryActions.clear.type: {
                return recorder.clear(state);
            }
            case HistoryActions.undo.type: {
                return recorder.undo(state);
            }
            case HistoryActions.redo.type: {
                return recorder.redo(state);
            }
            case HistoryActions.record.type: {
                return recorder.record(state);
            }
            case HistoryActions.commit.type: {
                return recorder.commit(state);
            }
            case HistoryActions.reject.type: {
                return recorder.reject(state);
            }
            default: {
                // Delegate handling the action to the passed reducer
                const newPresent = reducer(present, action);
                if (present === newPresent) {
                    return state;
                }
                // update history if any undoable key has been changed
                const undoForbidden = action.undoable === false ||
                    ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.undoable) === false;
                const canUndo = !undoForbidden &&
                    undoableKeys.some(key => newPresent[key] !== present[key]);
                // Only change current state don't mess with time
                if (!canUndo) {
                    return recorder.replace(newPresent);
                }
                // God mode - you rule the time
                return recorder.reduce(state, newPresent);
            }
        }
    };
}
